import styles from "./index.module.scss";

export default function FeaturesTag({ value, label, images, url }: any) {
  return (
    <div className={styles.featureBox}>
        {/* <a className={styles.featDetail} href={url?.url} target='_blank'> */}
        <div className={styles.featDetail}>
          <img src={images} alt="" width={30} />
          <span className={styles.number}>
            {label === "Built in " ? "" : value}{" "}
            <span className={styles.text}>
              {label === "Built in " ? `Built in ${value}` : label}
            </span>
          </span>
        </div>
        {/* </a> */}
    </div>
  );
}
